export default ":host ::ng-deep .mat-form-field {\n  padding: 0 !important;\n}";